import { createSlice } from "@reduxjs/toolkit";
import { IButtonSlice } from "../../../models/master/buttons";


const initialButtonState: IButtonSlice = {
  buttons:undefined,
  button:undefined
};

const buttonSlice = createSlice({
  name: "button",
  initialState: initialButtonState,
  reducers: {
    setButtons: (state, action: { payload: any }) => {
      state.buttons = action.payload;
    },
    setButton: (state, action: { payload: any }) => {
      state.button = action.payload;
    },
    
  },
});

export const { setButtons,setButton } =
buttonSlice.actions;

const buttonReducer = buttonSlice.reducer;

export type buttonState = ReturnType<typeof buttonReducer>;

export default buttonReducer;
